import type React from 'react';

import { ChecklistEvaluationKey } from 'types';
import type { EvaluationView, EvaluationParams, EvaluationState } from 'types';

import { ArrayPitchEvaluationInput } from './evaluations/ArrayPitchEvaluationInput';
import { SerialValidationEvaluationInput } from './evaluations/SerialValidationEvaluationInput';
import { SolarEdgeOptimizerEvaluationInput } from './evaluations/SolarEdgeOptimizerEvaluationInput';
import { SystemLossEvaluationInput } from './evaluations/SystemLossEvaluationInput';
import {
  FirstYearProductionEvaluationInput,
  SystemSizeEvaluationInput,
} from './evaluations/SystemSizeEvaluationInput';

export interface EvaluationInputComponentProps {
  inputKey: string;
  label: string;
  view: EvaluationView | undefined;
  params: EvaluationParams;
  readOnly: boolean;
  onChange: (state: EvaluationState) => void;
  // Only components that call a server endpoint on demand (e.g. SerialValidationEvaluationInput's
  // Check button) use this; others ignore it.
  itemKey?: string;
}

export interface EvaluationClientDescriptor {
  key: ChecklistEvaluationKey;
  Component: React.FC<EvaluationInputComponentProps>;
}

// ChecklistItemInputs looks up a Component here by key and renders it; unregistered keys render nothing.
export const evaluationClientRegistry: Record<ChecklistEvaluationKey, EvaluationClientDescriptor> = {
  [ChecklistEvaluationKey.systemSize]: {
    key: ChecklistEvaluationKey.systemSize,
    Component: SystemSizeEvaluationInput,
  },
  [ChecklistEvaluationKey.firstYearProduction]: {
    key: ChecklistEvaluationKey.firstYearProduction,
    Component: FirstYearProductionEvaluationInput,
  },
  [ChecklistEvaluationKey.arrayPitch]: {
    key: ChecklistEvaluationKey.arrayPitch,
    Component: ArrayPitchEvaluationInput,
  },
  [ChecklistEvaluationKey.serialValidation]: {
    key: ChecklistEvaluationKey.serialValidation,
    Component: SerialValidationEvaluationInput,
  },
  [ChecklistEvaluationKey.solarEdgeOptimizerValidation]: {
    key: ChecklistEvaluationKey.solarEdgeOptimizerValidation,
    Component: SolarEdgeOptimizerEvaluationInput,
  },
  [ChecklistEvaluationKey.systemLoss]: {
    key: ChecklistEvaluationKey.systemLoss,
    Component: SystemLossEvaluationInput,
  },
};
